import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";
import * as styles from "./style.css";
import QrReader from 'react-qr-reader';

import Icon from '../../../../icons/Icon';
import StickersComponentsScannerHeader from '../../components/scanner-header';
import QRCodeEnter from '../enter-code';
import Div100vh from "../../../../uq-ui/components/div-100";
import UQButton from "../../../../uq-ui/components/button";
import UserAgent from '../../../../uq-ui/helpers/express-useragent';
import * as Noty from 'noty';

const topRightImg = require('./img/top-right.png');
const topLeftImg = require('./img/top-left.png');
const bottomRightImg = require('./img/bottom-right.png');
const bottomLeftImg = require('./img/bottom-left.png');

class QRCodeScan extends PureComponent {
  static defaultProps = {
    goBack: () => {},
    onQREntered: () => {},
    onEnterPressed: () => {}
  };

  static propTypes = {
    goBack: PropTypes.func,
    onQREntered: PropTypes.func,
    onEnterPressed: PropTypes.func,
    error: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.state = {
      negativeIndent: 0,
      inputError: false
    };
    this.setupDesktopStyles();
  }

  componentDidMount() {
    this.setupNegativeIndent();
  }

  setupDesktopStyles = () => {
    const userAgent = new UserAgent().parse(navigator.userAgent);
    this.isDesktop = userAgent.isDesktop;
    if (this.isDesktop) {
      this.desktopViewportWidth = document.body.clientHeight * 0.56;
    }
  }

  onScan(content) {
    if (!content) return;
    if (content.includes('/')) {
      this.props.onQREntered(content.split('/').pop());
    } else {
      this.setState({ inputError: true });
    }
  }

  setupNegativeIndent() {
    if (this.isDesktop) {
      const negativeIndent = Math.abs(document.body.clientHeight - this.desktopViewportWidth)/2;
      this.setState({ negativeIndent });
    } else {
      const negativeIndent = Math.abs(document.body.clientHeight - document.body.clientWidth)/2;
      this.setState({ negativeIndent });
    }
  }

  onBackPressed = () => {
    this.props.goBack();
  }

  onEnterPressed = () => {
    this.props.onEnterPressed();
  }

  renderOverflow() {
    const middleOverlowsHeight = this.desktopViewportWidth ? { height: this.desktopViewportWidth*0.75 } : { height: '75vw' };
    const topOverflowStyle =  { height: '20vh' };
    if (window.screen.height < 550) { topOverflowStyle.height = '15vh' }
    return (
      <div className={styles.overflowContainer}>
        <div className={styles.overflowTop} style={topOverflowStyle}></div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div className={styles.overflowLeft} style={middleOverlowsHeight}></div>
          <div style={{ position: 'relative', width: '75vw' }}>
            <img src={topLeftImg} className={styles.topLeftImg} />
            <img src={topRightImg} className={styles.topRightImg} />
            <img src={bottomLeftImg} className={styles.bottomLeftImg} />
            <img src={bottomRightImg} className={styles.bottomRightImg} />
          </div>
          <div className={styles.overflowRight} style={middleOverlowsHeight}></div>
        </div>
        <div className={styles.overflowBottom}>
          {(this.state.inputError || this.props.error) && 
            <div className={styles.inputError} style={{ position: 'absolute' }}>
              <Icon name="InputError" style={{ width: 21, height: 21, marginRight: 5 }}/> 
              <div className={`${styles.inputErrorText} font-text`}>{this.props.t('error')}</div>
            </div>}
          <span className={`${styles.description} font-text`}>{this.props.t('description')}</span>
          <div className={styles.controlsContainer}>
            <UQButton label={this.props.t('backBtn')}
                      containerClass={styles.backBtn}
                      containerStyle={{ minWidth: 140 }}
                      theme={'whiteBrand'} 
                      onPress={this.onBackPressed}/>
            <UQButton label={this.props.t('scan')}
                      containerStyle={{ minWidth: 140 }}
                      theme={'brand'} 
                      onPress={this.onEnterPressed}/>
          </div>
        </div>
      </div>
    );
  }

  handleError = (err) => {
    new Noty({
      type: 'info',
      text: err.message,
      timeout: 2000,
    }).show();
    this.onEnterPressed();
  }

  handleScan = (content) => {
    this.onScan(content);
  }

  render() {
    const { negativeIndent } = this.state;
    return (
      <Fragment>
        <StickersComponentsScannerHeader  title={this.props.t('headerTitle')}/>
        <Div100vh className={styles.container}>
          <div className={styles.scannerContainer} >
          <QrReader
              delay={2000}
              onError={this.handleError}
              onScan={this.handleScan}
              showViewFinder={false}
              style={{ position: 'absolute', width: '100vh', left: `-${negativeIndent}px`}}
            />
          </div>
          { this.renderOverflow() }
        </Div100vh>
      </Fragment>
    );
  }
}

export default withTranslation('cmp-code-scan')(QRCodeScan);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/scan-code/index.jsx